import type { Audiencia, Expediente, Plazo } from '../types'
import { diasRestantes } from './fechas'

export function plazosVigentes(plazos: Plazo[]): Plazo[] {
  return plazos
    .filter((p) => !p.cumplido)
    .sort((a, b) => (a.fechaLimite < b.fechaLimite ? -1 : 1))
}

export function plazosDe(plazos: Plazo[], expedienteId: string): Plazo[] {
  return plazos
    .filter((p) => p.expedienteId === expedienteId)
    .sort((a, b) => (a.fechaLimite < b.fechaLimite ? -1 : 1))
}

export function proximoPlazo(plazos: Plazo[], expedienteId: string): Plazo | undefined {
  return plazosVigentes(plazos).find((p) => p.expedienteId === expedienteId)
}

export function audienciasDe(audiencias: Audiencia[], expedienteId: string): Audiencia[] {
  return audiencias
    .filter((a) => a.expedienteId === expedienteId)
    .sort((a, b) => (a.fecha < b.fecha ? -1 : 1))
}

export function esEstaSemana(iso: string): boolean {
  const d = diasRestantes(iso)
  return d >= 0 && d <= 6
}

export function coincideBusqueda(
  exp: Expediente,
  termino: string,
  nombresAbogados: string,
): boolean {
  const q = termino.trim().toLowerCase()
  if (!q) return true
  return [
    exp.localizador,
    exp.cliente,
    exp.numeroJudicial,
    exp.materia,
    exp.tipoAsunto,
    exp.autoridad,
    nombresAbogados,
    `${exp.ubicacion.almacen} ${exp.ubicacion.pasillo} ${exp.ubicacion.estante} ${exp.ubicacion.caja}`,
  ]
    .join(' ')
    .toLowerCase()
    .includes(q)
}
